import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import ProductSearchResult from './productSearchResult';
import ChangeZipCode from '../common/changeZipCode';

import {
	saveNarrowYourResultSelectedValue,
	saveProductLineFilters,
	resetProductNumberKeywordResultList,
	saveProductLine,
	saveProductLineNarrowYourResultsFilters,
	getProductLineNarrorYourResultFilters,
	updateAvailabilityWithPricesAndDiscounts,
	getProductLineFilters,
	resetProductAvailabilityResultList,
	getQuoteModels
} from '../../../redux/actions';

import ExportProductPriceInfoOverlayDialog from '../../dialogs/exportProductPriceInfoOverlayDialog';
import SuccessPriceTemplateConfirmation from '../../dialogs/successPriceTemplateConfirmation';

class SearchResult extends Component {

    constructor(props){
        super(props);
        this.state = {
			searchStrQuoteModels: null,
			showSuccessPriceTemplateConfirmation: false,

            errorMessage: "",
            typeOfSearch: "",

			selectedNarrowYourResult: "",
			hideNarrowByFilters: true,

			showExportProductPriceDialog: false,

			navigationState: '',

			getFilters: false,

			noRecordFound: false,
			filteredAvailQty : false,
			filterNLA :false,
			filterNLA : true,
        }
		this.fetchProductLineSearchResult = this.fetchProductLineSearchResult.bind(this);
		this.getZipCode = this.getZipCode.bind(this);
		this.handleSelectAvail = this.handleSelectAvail.bind(this);
		this.handleExcludeNla = this.handleExcludeNla.bind(this);
    }

	getZipCode() {
		return this.props.customZipCode;
	}

	componentWillMount() {
		if (this.props.params.typeOfSearch === 'quote-models' && this.props.state.user.selectedPriceSource['Quote Type'] !== 'Q') {
			browserHistory.push('/home');
		}
		this.setState({
			filterNLA: this.props.state.product.fromWhere !== "Search_Button"
		});
	}

	componentDidUpdate(prevProps) {
		if (prevProps.state.product.fromWhere !== this.props.state.product.fromWhere) {
			this.setState({
				filterNLA: this.props.state.product.fromWhere !== "Search_Button"
			});
		}
	}

	componentWillReceiveProps(nextProps) {
		const self = this;
		// update local state with zipcode, this is useful when page is getting refreshed
		if (self.props.customZipCode && nextProps.customZipCode && self.props.customZipCode !== nextProps.customZipCode) {
			self.props.resetProductAvailabilityResultList();
			setTimeout(() => {
				self.setState({
					onlyAvailabilityCall: true
				}, () => {
					self.checkAvailabilityAndAll();
				});
			}, 40);
		}

		if(
			(self.props.state.user.selectedAddress && self.props.state.user.selectedAddress !== nextProps.state.user.selectedAddress) ||
			(self.props.state.user.selectedADC && self.props.state.user.selectedADC !== nextProps.state.user.selectedADC &&
				nextProps.state.user.selectedPriceSource.AGREEMENT_NUMBER === self.props.state.user.selectedPriceSource.AGREEMENT_NUMBER
			)
		) {
			self.props.resetProductAvailabilityResultList();
			setTimeout(() => {
				self.setState({
					onlyAvailabilityCall: true,
				}, () => {
					self.checkAvailabilityAndAll();
				})
			}, 40);
		}
		if(nextProps.state.user.selectedPriceSource.AGREEMENT_NUMBER !== this.props.state.user.selectedPriceSource.AGREEMENT_NUMBER) {
			if(nextProps.params.typeOfSearch === 'quote-models') {
				if (nextProps.state.user.selectedPriceSource['Quote Type'] !== 'Q') {
					browserHistory.push('/home');
				} else {
					self.setState({
						searchStrQuoteModels: null
					}, () => {
						self.props.resetProductAvailabilityResultList();
						self.checkAvailabilityAndAll();
					});
				}
			} else {
				self.fetchSearchResultData(nextProps, true);
			}
		}
		if(nextProps.params.searchKeyword !== self.props.params.searchKeyword) {
			self.setState({
				selectedNarrowYourResult: self.props.state.product.productLine.navigationState,
				typeOfSearch: nextProps.params.typeOfSearch,
				hideNarrowByFilters: true
			});
			//Clear filter first time once user comes first on this page after searching from login page
			self.props.saveProductLineFilters(null);

			if (nextProps.params.typeOfSearch === 'product-number') {
				self.fetchSearchResultData(nextProps, false);
			}
		}

		if(self.props.params.typeOfSearch !== 'quote-models' && nextProps.params.typeOfSearch === 'quote-models') {
			//Clear filter first time once user comes first on this page after searching from login page
			self.props.saveProductLineFilters(null);
			self.props.resetProductAvailabilityResultList();
			self.setState({
				selectedNarrowYourResult: self.props.state.product.productLine.navigationState,
				typeOfSearch: nextProps.params.typeOfSearch,
				hideNarrowByFilters: true,
				searchStrQuoteModels: null
			}, () => {
				self.checkAvailabilityAndAll();
			});
		}
	}

	fetchSearchResultData(nextProps, availabilityAndPricingCallRequired) {
		const self = this;
		const { selectedAccount, selectedPriceSource } = nextProps.state.user;
		self.props.checkAndSetSearchResult(
			nextProps.params.typeOfSearch,
			selectedAccount.ACCOUNTNUMBER,
			selectedPriceSource.AGREEMENT_NUMBER,
			self.getZipCode(),
			decodeURI(nextProps.params.searchKeyword),
			"",
			response => {
				// Check if both (prices and availability) service call are completed or not
				if(self.props.state.product.numberOfParallelCallForProductPrices === self.props.state.product.numberCompletedOfParallelCallForProductPrices && self.props.state.product.isProductAvailabilityCallCompleted) {
					// add prices to availability existing object and update it in to store before redirecting to search result page
					self.props.updateAvailabilityWithPricesAndDiscounts();
				}
			},
			false,
			availabilityAndPricingCallRequired
		);
	}

	handleDialogStatus(flag, event) {
		event && event.preventDefault();
        this.setState({
            showExportProductPriceDialog: flag
        });
    }

	handleDialogStatusRunExportConfirm(flag, event) {
		event && event.preventDefault();
        this.setState({
            showSuccessPriceTemplateConfirmation: flag
        });
	}

	handleDialogStatusExport(flag, isEmailSent, event) {
		event && event.preventDefault();
		var self = this;
		if(isEmailSent) {
			self.setState({
				showSuccessPriceTemplateConfirmation: false,
			}, () => {
				self.setState({
					showSuccessPriceTemplateConfirmation: true,
					showExportProductPriceDialog: flag
				});
			});
		} else {
			self.setState({
				showExportProductPriceDialog: flag
			});
		}
    }

    componentDidMount() {
		const self = this;
		const myInt = setInterval(() => {
			const selectedADC = self.props.state.user.selectedADC;
			if (selectedADC) {
				clearInterval(myInt);
				self.checkAvailabilityAndAll();
			}
		}, 50);
    }

	checkAvailabilityAndAll() {
		const self = this;
		const typeOfSearch = self.props.params.typeOfSearch;

		self.setState({
			typeOfSearch
		}, () => {
			if(!self.props.state.product.productResultAvailability) {
				const { selectedAccount, selectedPriceSource } = self.props.state.user;
				if(typeOfSearch === 'product-line') {
					const searchKeyword = decodeURI(self.props.params.searchKeyword).split("|");
					const navigationState = "?" + searchKeyword[1],
						label = searchKeyword[0];

					self.setState({
						selectedNarrowYourResult: navigationState
					});

					self.props.saveProductLine({
						navigationState,
						label: label
					});

					this.props.checkAndSetSearchResult(
						'product-line',
						selectedAccount.ACCOUNTNUMBER,
						selectedPriceSource.AGREEMENT_NUMBER,
						self.getZipCode(),
						"",
						navigationState,
						response => {
							// Check if both (prices and availability) service call are completed or not
							if(self.props.state.product.numberOfParallelCallForProductPrices === self.props.state.product.numberCompletedOfParallelCallForProductPrices && self.props.state.product.isProductAvailabilityCallCompleted) {
								// add prices to availability existing object and update it in to store before redirecting to search result page
								self.props.updateAvailabilityWithPricesAndDiscounts();
								self.setState({
									onlyAvailabilityCall: false
								});
							}
						},
						self.state.onlyAvailabilityCall
					);
					if(!self.state.onlyAvailabilityCall) {
						//Make parallel call for narrow your result filters
						self.props.saveProductLineNarrowYourResultsFilters(null);
						//get categoryId
						const categoryId = navigationState.replace('?N=','');
						self.props.getProductLineNarrorYourResultFilters("requestType=getProductLine&categoryId="+categoryId);
					}
				} else if (typeOfSearch === 'product-number') {
					self.props.checkAndSetSearchResult(
						'product-number',
						selectedAccount.ACCOUNTNUMBER,
						selectedPriceSource.AGREEMENT_NUMBER,
						self.getZipCode(),
						decodeURI(self.props.params.searchKeyword),
						"",
						response => {
							// Check if both (prices and availability) service call are completed or not
							if(self.props.state.product.numberOfParallelCallForProductPrices === self.props.state.product.numberCompletedOfParallelCallForProductPrices && self.props.state.product.isProductAvailabilityCallCompleted) {
								// add prices to availability existing object and update it in to store before redirecting to search result page
								self.props.updateAvailabilityWithPricesAndDiscounts();
								self.setState({
									onlyAvailabilityCall: false
								});
							}
						},
						self.state.onlyAvailabilityCall
					);
				} else if (typeOfSearch === 'quote-models') {
					self.getQuotemodelsIfNotExists((searchStr) => {
						self.props.checkAndSetSearchResult(
							typeOfSearch,
							selectedAccount.ACCOUNTNUMBER,
							selectedPriceSource.AGREEMENT_NUMBER,
							self.getZipCode(),
							self.state.searchStrQuoteModels,
							"",
							response => {
								// Check if both (prices and availability) service call are completed or not
								if(self.props.state.product.numberOfParallelCallForProductPrices === self.props.state.product.numberCompletedOfParallelCallForProductPrices && self.props.state.product.isProductAvailabilityCallCompleted) {
									// add prices to availability existing object and update it in to store before redirecting to search result page
									self.props.updateAvailabilityWithPricesAndDiscounts();
									self.setState({
										onlyAvailabilityCall: false
									});
								}
							},
							self.state.onlyAvailabilityCall
						);
					});
				}
			}
		});
	}
	getQuotemodelsIfNotExists(callback) {
		const self = this;
		const { selectedPriceSource } = self.props.state.user;
		if (!self.state.searchStrQuoteModels) {
			self.props.getQuoteModels(`requestType=getQuoteModels&accountNumber=${self.props.getSelectedAccountNumber()}&salesAgreement=${selectedPriceSource.AGREEMENT_NUMBER}`, response => {
				const responseObject = JSON.parse(response.responseObject);
				const items = _.chunk(responseObject.map(item => item.item_number), 10);
				const searchStr = [];
				items.forEach(item => {
					searchStr.push(item.join(" "));
				});
				self.setState({
					searchStrQuoteModels: searchStr
				}, () => {
					callback && callback(self.state.searchStrQuoteModels);
				});
			});
		} else {
			callback && callback(self.state.searchStrQuoteModels);
		}
	}
    handleNarrowYourResults(event) {
		const self = this;
		const label = event.target.options[event.target.selectedIndex].innerText,
			value = event.target.value;
		self.setState({
			hideNarrowByFilters: value === this.props.state.product.productLine.navigationState,
			selectedNarrowYourResult: value,
			selectedNarrowYourResultLabel: label,
			narrowFilterChanged: true,
			checkboxFilterChecked: null,
		}, () => {
			self.props.saveNarrowYourResultSelectedValue({
				value,
				label
			});
			self.fetchProductLineSearchResult(value, self.state.typeOfSearch);
		});
    }

	fetchProductLineSearchResult(navigationState, typeOfSearch) {
        const self = this;
        const { selectedAccount, selectedPriceSource } = self.props.state.user;

		self.props.checkAndSetSearchResult(
			typeOfSearch,
			selectedAccount.ACCOUNTNUMBER,
			selectedPriceSource.AGREEMENT_NUMBER,
			self.getZipCode(),
			"",
			navigationState,
			response => {
				// Check if both (prices and availability) service call are completed or not
				if(self.props.state.product.numberOfParallelCallForProductPrices === self.props.state.product.numberCompletedOfParallelCallForProductPrices && self.props.state.product.isProductAvailabilityCallCompleted) {
					// add prices to availability existing object and update it in to store before redirecting to search result page
					self.props.updateAvailabilityWithPricesAndDiscounts();

					//get filters if product line is the type of search,
					//filter will be get once after getting actual available products only
					//Prepare list of sku list of available products
					const skuList = [];
					self.props.state.product.productResultAvailability.forEach((item, index) => {
						skuList.push({
							"sku": item.sku
						});
					});
					if(self.state.narrowFilterChanged) {
						self.setState({
							narrowFilterChanged: false,
						});
					}
					if(self.state.checkboxFilterChecked) {
						self.props.fireGTMTag('Postlogin Search Result Filter', {
							filterCategory: self.state.selectedNarrowYourResultLabel,
							filterTerm: self.state.checkboxFilterChecked,
							filterResults: self.props.state.product.productResultAvailability.length
						});
					} else {
						self.props.fireGTMTag('Postlogin Search Result Filter', {
							filterCategory: self.props.state.product.productLine.label,
							filterTerm: self.state.selectedNarrowYourResultLabel,
							filterResults: self.props.state.product.productResultAvailability.length
						});
					}
					skuList.length > 0 && self.props.getProductLineFilters(skuList, navigationState.replace("?", ""));
				}
			}
		);
    }

	handleFilterCheck(displayName, filterName, navigationState, event) {
		const self = this;
		let { product } = self.props.state;
		if(product && product.productLineFilters) {
			var original = product.productLineFilters;
			original.filters.map((item, index) => {
				if(item.displayName === displayName) {
					item.values.map((itm, ind) => {
						if(itm.value === filterName) {
							itm.checked = event.target.checked;
						}
						return null;
					});
				}
				return null;
			});
			product.productLineFilters = original;
		}
		if(event.target.checked === false)
			navigationState = navigationState.substring(0, navigationState.lastIndexOf('+'))
		self.setState({
			checkboxFilterChecked: event.target.checked ? filterName : null,
		}, () => {
			self.fetchProductLineSearchResult(navigationState, self.state.typeOfSearch);
		});
    }

    clearAllFilters(event) {
		event.preventDefault();
        const self = this,
			{ productLine } = self.props.state.product;

		self.setState({
			selectedNarrowYourResult: productLine.navigationState,
			hideNarrowByFilters: true,
			checkboxFilterChecked: null,
		});

		//Clear filter first time once user comes first on this page after searching from login page
		self.props.saveProductLineFilters(null);
		//Reset List first then new values will be added
		self.props.resetProductNumberKeywordResultList();

        this.fetchProductLineSearchResult(productLine.navigationState, this.state.typeOfSearch);
    }

	handleSelectAvail(e){
		this.setState({
		   filteredAvailQty: e.target.checked ? true:false
		})
   }

   handleExcludeNla(e){
	this.setState({
		filterNLA :e.target.checked? true :false
	})
}

    render() {
        var self = this,
            narrowByFilters = [];
		const isPunchOutAccess = self.props.isPunchOutAccess()
        const { state } = self.props,
			{ userDetails, selectedAccount } = state.user;
        let { resultLoaded, productResultAvailability } = state.product;
		if(state.product.productLineFilters && !_.isEmpty(state.product.productLineFilters.filters)) {
			narrowByFilters = state.product.productLineFilters.filters
        }
		if(self.state.filteredAvailQty){
			productResultAvailability = resultLoaded &&	productResultAvailability && productResultAvailability.filter(avail=> {
		 	return avail.availableQty>0
		 	});
		 }
		 if(self.state.filterNLA){
			let { productNumberKeywordResult } = self.props.state.product; 
			productResultAvailability =  resultLoaded && productResultAvailability && productResultAvailability.length > 0 && productResultAvailability.filter((item, index) => {
			   let lifeCyclePhaseValueMultipleValues =productNumberKeywordResult && productNumberKeywordResult.filter(itm => itm.sku === item.sku);
			   let lifeCyclePhaseValue = lifeCyclePhaseValueMultipleValues && lifeCyclePhaseValueMultipleValues.length > 0 ? lifeCyclePhaseValueMultipleValues[0].lifeCyclePhase : null;
			   if(!(self.props.checkIfFP(item) || lifeCyclePhaseValue === "Near End of Life")){
				   return item
			   }
			});
		}
    	return (
            <div>
               	<p><b>{this.state.errorMessage}</b></p>
				<h1>
					{this.state.typeOfSearch==='product-line'?_.unescape(state.product.productLine.label):null}
					{this.state.typeOfSearch==='quote-models'?'Quote Models':null}
				</h1>
                <h2 className={this.state.typeOfSearch==='product-number'?"":"hide"}>
					<span style={{fontWeight: 'normal'}}>You searched:</span>&nbsp;
					{self.props.params.searchKeyword?self.props.params.searchKeyword.replace(/ /g, ', ').toUpperCase():''}
				</h2>
               	{/*<p>
                  	<b>Results shown are for:</b> &nbsp; &nbsp; Account # {selectedAccount.ACCOUNTNUMBER} &nbsp;&nbsp; {selectedADC === defaultSelectedADC ? <span>Zip Code {self.props.getZipCode()}</span> : <span>ADC : {selectedADC}</span>}
               	</p>*/}
				<ChangeZipCode
					saveCustomADC={self.props.saveCustomADC}
					customADC={self.props.customADC}
					selectedAccount={selectedAccount}
					getShippingAddressesDetails={this.props.getShippingAddressesDetails}
					acceptNumbersOnly={this.props.acceptNumbersOnly}
					handleSelectZipCode={this.props.saveCustomZipCode}
					accountNumber={this.props.getSelectedAccountNumber()}
					zipCode={this.props.customZipCode}
					typeOfAccount={self.props.getSelectedAccountType()}
					handleSelectAvail={this.handleSelectAvail.bind(this)}
					handleExcludeNla={this.handleExcludeNla.bind(this)}
					filteredAvailQty ={this.state.filteredAvailQty}	
					filterNLA ={this.state.filterNLA}	
					showInStockFilter={true}
					showExcludeNlaFilter={true}
				/>
				{this.state.typeOfSearch === 'product-line'
                 	?<div>
                     	<h2 className="blue">
                         	<span className="withIcon withFilterIcon">Narrow Your Results (optional)</span>
                     	</h2>
                     	<form className="narrowResultsForm withNoBeforeUnloadBehavior">
							<select name="narrow" onChange={this.handleNarrowYourResults.bind(this)} value={this.state.selectedNarrowYourResult} disabled={!state.product.productLineNarrowYourResultsFilter || (state.product.productLineNarrowYourResultsFilter && state.product.productLineNarrowYourResultsFilter.length === 0)}>
								<option value={state.product.productLine.navigationState}>All {_.unescape(state.product.productLine.label)}</option>
								{state.product.productLineNarrowYourResultsFilter && state.product.productLineNarrowYourResultsFilter.map((item, index) => {
									return <option key={index} value={"?N=" + item.categoryId}>{item.name}</option>
								})}
							</select>
                        </form>
                        <div id="narrowBy" className={"narrowBy "+(this.state.hideNarrowByFilters?"hide":"")}>
                            <div className="narrowBy_inner1">
                               	<div className="narrowBy_inner2">
                                  	<div className="narrowBy_inner3">
                                     	<div className="narrowBy_inner4">
	                                        <div className="heading">
	                                           <h2>Narrow By <span className="unbold">(Optional)</span></h2>
	                                           <p className="clearAllParagraph"><a href="" onClick={this.clearAllFilters.bind(this)}>Clear All</a></p>
	                                        </div>
                                        	<div id="filtersContainer">
                                             	{narrowByFilters.map((item, index) => {
                                                 	return <div className="filterBox" key={index}>
                                                    	<div className="filterBox_inner">
                                                       		<div className="filterBox_inner2" style={{overflow: 'hidden'}}>
                                                          		<h3 className="filterHeading" alt={item.displayName.toUpperCase()} title={item.displayName.toUpperCase()}>{item.displayName}</h3>
                                                          		<div className="checkboxContainer">
                                                             		{item.values.map((itm, ind) => {
                                                                 		return <div key={ind} className={"checkboxDiv "+(itm.disable?'disabledCheckboxDiv':'')}>
 																			{itm.checked?
		 																		<input type="checkbox" checked={!itm.checked?false:true} className="checkbox" disabled={!itm.disable?false:true} onChange={self.handleFilterCheck.bind(this, item.displayName, itm.value, itm.dimensionId)} id={"checkbox_"+index+"_"+ind} defaultValue={itm.dimensionId} />
		 																		:<input type="checkbox" checked={!itm.checked?false:true} className="checkbox" disabled={!itm.disable?false:true} onChange={self.handleFilterCheck.bind(this, item.displayName, itm.value, itm.dimensionId)} id={"checkbox_"+index+"_"+ind} defaultValue={itm.dimensionId} />
	 																		}
	                                                                    	<label htmlFor={"checkbox_"+index+"_"+ind} style={{cursor: 'pointer'}}>{itm.value}</label>
                                                                 		</div>
                                                             		})}
                                                          		</div>
                                                       		</div>
                                                		</div>
                                                 	</div>
                                             	})}
                                           		<div style={{clear: 'both'}}></div>
                                        	</div>
                                       		<div style={{clear: 'both'}}></div>
                                     	</div>
                                  	</div>
                               	</div>
                            </div>
                     	</div>
                    </div>
                :null}
				{resultLoaded && productResultAvailability && productResultAvailability.length > 0 && !isPunchOutAccess
					?<p className="textRight">
						<a className="withIcon withExportIcon noUnderline uppercase bold" href="" onClick={this.handleDialogStatus.bind(this, true)}>Export Product / Price Info</a>
					</p>
					:null
				}
				{((this.props.state.user.localUserDetails || userDetails.typeOfUser === 'employee') && this.state.showExportProductPriceDialog)
					?<ExportProductPriceInfoOverlayDialog
						getOrgAttributesByAttributeName={this.props.getOrgAttributesByAttributeName}
						isAccessToMAPGuidelines={this.props.isAccessToMAPGuidelines}
						getZipCode={this.getZipCode}
						getLegacyCustCode={this.props.getLegacyCustCode}
						typeOfSearch={this.state.typeOfSearch}
						searchKeyword={this.props.params.searchKeyword}
						isPricingAccess={this.props.isResponsibilityExists("Price")}
						isPriceDiscountAccess={this.props.isResponsibilityExists("Price Discounts")}
						handleDialogStatusExport={this.handleDialogStatusExport.bind(this)}
						showDialog={true}
						getShippingAddressesDetails={this.props.getShippingAddressesDetails}
						typeOfAccount={this.props.getSelectedAccountType()}
						customADC={this.props.customADC}
					/>
					:null
				}
            	{(this.props.state.user.localUserDetails || userDetails.typeOfUser === 'employee') && <ProductSearchResult
					checkIfFP={this.props.checkIfFP}
					selectedNarrowYourResult={this.state.selectedNarrowYourResult}
					validateFDD={this.props.validateFDD}
					getShippingAddressesDetails={this.props.getShippingAddressesDetails}
					isResponsibilityExists={this.props.isResponsibilityExists}
					getZipCode={this.getZipCode}
					getLegacyCustId={this.props.getLegacyCustId}
					getLegacyCustCode={this.props.getLegacyCustCode}
					searchKeyword={this.props.params.searchKeyword}
					customerType={self.props.getSelectedAccountType()}
					dispatch={self.props.dispatch}
					productResultAvailability={productResultAvailability}
					typeOfSearch={this.state.typeOfSearch}
					accountNumber={this.props.getSelectedAccountNumber()}
					formatETADate={this.props.formatETADate}
					fireGTMTag={this.props.fireGTMTag}
					checkAvailabilityGeneric={this.props.checkAvailabilityGeneric}
					getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability}
				/>}
				{this.state.showSuccessPriceTemplateConfirmation?<SuccessPriceTemplateConfirmation saveTemplateOrNot={false} handleDialogStatus={this.handleDialogStatusRunExportConfirm.bind(this)} showDialog={true} />:null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	saveNarrowYourResultSelectedValue: (data) => dispatch(saveNarrowYourResultSelectedValue(data)),
	saveProductLineFilters: (data) => dispatch(saveProductLineFilters(data)),
	resetProductNumberKeywordResultList: () => dispatch(resetProductNumberKeywordResultList()),
	saveProductLine: (data) => dispatch(saveProductLine(data)),
	saveProductLineNarrowYourResultsFilters: (data) => dispatch(saveProductLineNarrowYourResultsFilters(data)),
	resetProductAvailabilityResultList: () => dispatch(resetProductAvailabilityResultList()),
	getProductLineNarrorYourResultFilters: (payload) => dispatch(getProductLineNarrorYourResultFilters(payload)),
	updateAvailabilityWithPricesAndDiscounts: () => dispatch(updateAvailabilityWithPricesAndDiscounts()),
	getQuoteModels: (queryStringParams, callback) => dispatch(getQuoteModels(queryStringParams, callback)),
	getProductLineFilters: (payload, hybridQueryParams, callback) => dispatch(getProductLineFilters(payload, hybridQueryParams, callback)),
});

SearchResult = connect(mapStateToProps, mapDispatchToProps)(SearchResult);
export default SearchResult;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/SearchResult/index.js